var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrutinyIcon11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48865 5.50519L15.0268 2.07275C15.0268 2.66043 10.8815 49.087 10.3633 50.2624C8.75861 37.5227 4.41607 17.1914 1.04513 8.54058C0.564106 7.30614 1.21082 5.85501 2.48865 5.50519Z",
    fill: "#CFD0D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9178 0H33.6809L48.1895 14.5087V27.4571C46.2371 25.6839 43.6442 24.6033 40.799 24.6033C34.7258 24.6033 29.8026 29.5266 29.8026 35.5997C29.8026 41.6729 34.7258 46.5961 40.799 46.5961C42.7403 46.5961 44.5642 46.093 46.1473 45.2101L48.1895 47.2524V49.226C48.1895 50.3707 47.2616 51.2987 46.1169 51.2987H11.9178C10.7731 51.2987 9.84509 50.3707 9.84509 49.226V2.07267C9.84509 0.927966 10.7731 0 11.9178 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9672 35.5056L39.5295 38.068L44.6543 33.7974",
    stroke: "white",
    strokeWidth: 1.74882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2123 41.1826L51.9999 46.9702",
    stroke: "white",
    strokeWidth: 1.74882,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6807 12.436V0L48.1894 14.5087H35.7534C34.6087 14.5087 33.6807 13.5807 33.6807 12.436Z",
    fill: "#CFD0D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 7.25439L27.5925 7.25439",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 11.3999L23.9653 11.3999",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 20.4028L44.1739 20.4028",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 24.4834H31.98",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 28.564H27.9811",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 32.6445H25.8623",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1564 36.7251H25.8623",
    stroke: "#323E4A",
    strokeWidth: 1.5545,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7989,
    cy: 35.5998,
    r: 7.80696,
    stroke: "white",
    strokeWidth: 1.74882
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrutinyIcon11);
export default __webpack_public_path__ + "static/media/Scrutiny Icon 1 1.e996014472fc9da1846e24eba1d22e4e.svg";
export { ForwardRef as ReactComponent };